<template>
  <div class="box box-primary" :class="{'collapsed-box': !ouvert}">
    <div class="box-header with-border">
      <h3 class="box-title">
        Factures enregistrées
        <small class="text-muted">({{ factures.length }})</small>
      </h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-default btn-xs" @click="exporter()"
                :disabled="!factures.length" title="Exporter toutes les factures en JSON">
          <i class="fa fa-download"></i> Exporter
        </button>
        <button type="button" class="btn btn-default btn-xs" @click="declencherImport()"
                title="Importer un fichier JSON de factures">
          <i class="fa fa-upload"></i> Importer
        </button>
        <input type="file" accept="application/json" class="champ-import"
               ref="champImport" @change="importer($event)">
        <button type="button" class="btn btn-box-tool" @click="ouvert = !ouvert">
          <i class="fa" :class="ouvert ? 'fa-minus' : 'fa-plus'"></i>
        </button>
      </div>
    </div>
    <div class="box-body no-padding" v-show="ouvert">
      <p v-if="!factures.length" class="aucune-facture">
        Aucune facture enregistrée. Le bouton « Enregistrer » (Ctrl+S) ajoute la facture
        en cours à cette liste, conservée dans ce navigateur uniquement.
      </p>
      <table v-else class="table table-hover table-condensed">
        <thead>
          <tr>
            <th>Numéro</th>
            <th>Client</th>
            <th>Date</th>
            <th class="text-right">Total</th>
            <th class="colonne-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="facture in factures" :key="facture.id">
            <td><strong>{{ facture.numero || '—' }}</strong></td>
            <td>{{ facture.client ? facture.client.nom : '' }}</td>
            <td>{{ facture.dateEmission }}</td>
            <td class="text-right">{{ totalDe(facture) }}</td>
            <td class="colonne-actions">
              <button type="button" class="btn btn-default btn-xs" title="Ouvrir"
                      @click="$emit('ouvrir', facture)">
                <i class="fa fa-folder-open-o"></i>
              </button>
              <button type="button" class="btn btn-default btn-xs" title="Dupliquer"
                      @click="$emit('dupliquer', facture)">
                <i class="fa fa-copy"></i>
              </button>
              <button type="button" class="btn btn-danger btn-xs" title="Supprimer"
                      @click="$emit('supprimer', facture)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script type="text/babel">
  const FileSaver = require('file-saver')
  import {calculerTotaux, formaterMontant} from '../../../utils/facture/calculs'

  export default {
    name: 'FactureHistorique',
    props: {
      factures: {type: Array, required: true}
    },
    data () {
      return {
        ouvert: true
      }
    },
    methods: {
      totalDe (facture) {
        return formaterMontant(calculerTotaux(facture).total, facture.devise)
      },
      /**
       * L'export JSON est la seule porte de sortie : l'historique vit dans le
       * localStorage de ce navigateur et disparaîtrait avec lui.
       */
      exporter () {
        const contenu = JSON.stringify({type: 'abft-factures', factures: this.factures}, null, 2)
        const blob = new Blob([contenu], {type: 'application/json;charset=utf-8'})
        FileSaver.saveAs(blob, 'factures-abft.json')
      },
      declencherImport () {
        this.$refs.champImport.click()
      },
      importer (evenement) {
        const fichier = evenement.target.files && evenement.target.files[0]
        if (!fichier) return

        const composant = this
        const lecteur = new FileReader()
        lecteur.onload = function () {
          try {
            const donnees = JSON.parse(lecteur.result)
            const liste = Array.isArray(donnees) ? donnees : donnees.factures
            if (!Array.isArray(liste)) throw new Error('Format inattendu')
            composant.$emit('importer', liste)
          } catch (erreur) {
            composant.$noty.error('Fichier illisible : JSON de factures attendu')
          }
          composant.$refs.champImport.value = ''
        }
        lecteur.onerror = function () {
          composant.$noty.error('Lecture du fichier impossible')
          composant.$refs.champImport.value = ''
        }
        lecteur.readAsText(fichier)
      }
    }
  }
</script>

<style scoped>
  .champ-import {
    display: none;
  }

  .colonne-actions {
    width: 110px;
    white-space: nowrap;
    text-align: right;
  }

  .aucune-facture {
    padding: 14px;
    margin: 0;
    color: #777;
  }

  .box-tools .btn-xs {
    margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Outils/Facture/FactureHistorique.vue